import GraficoScorePeriodo from '../../../RiscoEditView/grafico/score_por_periodo';
import { useState, useEffect } from 'react';
import http from 'src/services/httpService';
import { getConfiguration } from 'src/services/commonRequests';
import { Row, Col } from 'src/componentes/grid';
import { connect } from 'react-redux';
import errorHandler from 'src/utils/error-handler';
import Button from 'src/componentes/button';
import LucideIcon from 'src/componentes/lucide-icon';
import Filtro from 'src/componentes/filtro';
import ContentManager from 'src/componentes/content-manager';
import Search from '../../../RiscoEditView/grafico/search';
import SearchSchema from '../../../RiscoEditView/grafico/searchSchema';
import { FILTROS } from 'src/utils/constants';
import { getFilter } from 'src/componentes/NewList';
import FiltroChip from 'src/componentes/filtro-chip';
import LoadingContainer from 'src/componentes/loading-container';

const Graficos = ({
  riscoId,
  exibirGraficoScorePeriodo = true,
  resources,
  updater,
  selectedFilter,
  exibirFiltros = true,
  thousandsSeparator = '.',
  decimalSeparator = ',',
  // Props para quando exibirFiltros = false (filtro controlado pelo pai)
  avaliacoes: avaliacoesFromParent, // Recebe avaliações do pai
  grausDaMatriz: grausDaMatrizFromParent, // Recebe graus do pai
  maiorScoreDaMatriz: maiorScoreDaMatrizFromParent, // Recebe maior score do pai
  handleSearch: handleSearchFromParent, // Recebe função de busca do pai
  searchModel: searchModelFromParent, // Recebe modelo de busca do pai
  ...props
}) => {
  const getFilterDefaultChart = () => {
    return {
      valor: {
        tipoFiltroData: null,
        dataInicio: null,
        dataTermino: null,
      },
    };
  };

  const [avaliacoes, setAvaliacoes] = useState([]);
  const [searchModelState, setSearchModel] = useState(getFilterDefaultChart());
  const [grausDaMatrizRisco, setGrausDaMatriz] = useState([]);
  const [maiorScoreDaMatriz, setMaiorScoreDaMatriz] = useState(0);
  const [configuracao, setConfiguracao] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const isControlledByParent = !exibirFiltros;

  useEffect(() => {
    getConfiguration('ItemConfiguracaoRisco')(setConfiguracao)();
  }, []);

  const refresh = async (searchModel) => {
    if (configuracao && riscoId > 0 && !isControlledByParent) {
      setIsLoading(true);
      if (!searchModel) {
        searchModel = await getFilter(FILTROS.RISCO_GRAFICOSCORE, true);
        setSearchModel(searchModel);
      }
      try {
        await http
          .post('/RiscoAvaliacao/ObterGraficoDeScore', {
            riscoId: riscoId,
            model:
              searchModel && searchModel.valor
                ? searchModel.valor
                : searchModel,
          })
          .then((response) => {
            setAvaliacoes(response.data.avaliacoes);
            setGrausDaMatriz(response.data.grausDaMatriz);
            setMaiorScoreDaMatriz(
              response.data.maiorScoreDaMatriz
                ? response.data.maiorScoreDaMatriz
                : 0
            );
            setIsLoading(false);
          });
      } catch (err) {
        errorHandler(err);
      }
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isControlledByParent) {
      if (avaliacoesFromParent) {
        setAvaliacoes(avaliacoesFromParent);
      }
      if (grausDaMatrizFromParent) {
        setGrausDaMatriz(grausDaMatrizFromParent);
      }
      if (maiorScoreDaMatrizFromParent !== undefined) {
        setMaiorScoreDaMatriz(maiorScoreDaMatrizFromParent);
      }
      setIsLoading(false);
    } else {
      refresh();
    }
  }, [
    configuracao,
    updater,
    ...(isControlledByParent
      ? [
          avaliacoesFromParent,
          grausDaMatrizFromParent,
          maiorScoreDaMatrizFromParent,
        ]
      : []),
  ]);

  const handleSearch = (searchModel) => {
    if (isControlledByParent && handleSearchFromParent) {
      handleSearchFromParent(searchModel);
    } else {
      setSearchModel(searchModel);

      if (searchModel && searchModel.valor) refresh(searchModel.valor);
    }
  };

  const handleFiltroModal = () => {
    const currentSearchModel =
      isControlledByParent && searchModelFromParent
        ? searchModelFromParent
        : searchModelState;

    ContentManager.addContent(
      <Filtro
        {...props}
        filtroId={FILTROS.RISCO_GRAFICOSCORE}
        usarFiltroSalvo={true}
        searchComponent={<Search />}
        searchSchema={SearchSchema}
        onSearch={handleSearch}
        showModal={true}
        selectedFilter={
          currentSearchModel ? currentSearchModel : getFilterDefaultChart()
        }
        ignorarCamposCustomizados={true}
      />
    );
  };

  const handleFiltroChip = () => {
    let searchModel;

    if (isControlledByParent && searchModelFromParent) {
      searchModel =
        searchModelFromParent.valor != null
          ? searchModelFromParent.valor
          : searchModelFromParent;
    } else {
      searchModel =
        searchModelState && searchModelState.valor != null
          ? searchModelState.valor
          : searchModelState;
    }

    return (
      <FiltroChip
        filtroId={FILTROS.RISCO_GRAFICOSCORE}
        onSearch={handleSearch}
        searchSchema={SearchSchema}
        selectedFilter={searchModel}
        onRemoveSaveFilter={true}
      />
    );
  };

  return (
    <div>
      {/* {configuracao && configuracao.habilitarCalculoDeScores && ( */}
      {configuracao && (
        <LoadingContainer isLoading={isLoading}>
          {exibirFiltros && (
            <Row>
              <Col md={10}>
                <div className={'mt-3 mr-1 pull-right'}>
                  {handleFiltroChip()}
                </div>
              </Col>
              <Col md={2}>
                <div className={'mt-3 mr-3 pull-right'}>
                  <Button
                    size="icon"
                    className="tw:ms-2"
                    onClick={handleFiltroModal}
                  >
                    <LucideIcon icon="Funnel" size={16} />
                  </Button>
                </div>
              </Col>
            </Row>
          )}
          {exibirGraficoScorePeriodo && (
            <Row>
              <Col md={12}>
                <GraficoScorePeriodo
                  handleSearch={handleSearch}
                  avaliacoes={avaliacoes}
                  grausDaMatriz={grausDaMatrizRisco}
                  maiorScoreDaMatriz={maiorScoreDaMatriz}
                  thousandsSeparator={thousandsSeparator}
                  decimalSeparator={decimalSeparator}
                />
              </Col>
            </Row>
          )}
        </LoadingContainer>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default connect(mapStateToProps)(Graficos);
